import React, { useCallback } from 'react';
import { Form, Field } from 'react-final-form';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

import Input from 'components/Input';
import Button from 'components/Button';
import Link from 'components/ui/Link';
import { validateSignInLogin } from 'utils/validation';
import { post } from 'utils/http';
import { notification } from 'antd';
import { handleError } from 'contexts/UserContext';
import { config } from 'config';
import { useSetLoginTitle } from './LoginContainer';
import StyledForm from './Form';

export default function RecoveryForm({ className }) {
  const { t } = useTranslation('login');
  useSetLoginTitle(t('title.recovery'));

  const history = useHistory();

  const handleRecovery = useCallback(
    async ({ login }) => {
      try {
        await post(
          '/users/auth/forgotpassword',
          { Username: login },
          { params: { action: 'request' } }
        );
        if (config.KEYCLOAK_AUTH) {
          history.push('/recovery/email-sent');
          return;
        }
        notification.info({ message: t('message.code_sent') });
        history.push(`/recovery/code?login=${login}`);
      } catch (e) {
        handleError(e, t('message.recovery_error'));
      }
    },
    [history, t]
  );

  return (
    <Form
      onSubmit={handleRecovery}
      render={({ handleSubmit, submitting, invalid, pristine }) => (
        <StyledForm className={className} onSubmit={handleSubmit}>
          <Field
            name="login"
            validate={validateSignInLogin}
            render={({ input, meta }) => (
              <Input
                disabled={submitting}
                label={t('fields.login')}
                {...input}
                error={meta.touched && meta.error}
              />
            )}
          />
          <Button type="submit" disabled={invalid || submitting || pristine}>
            {t('actions.recovery')}
          </Button>
          {config.KEYCLOAK_AUTH ? null : (
            <Link to="/recovery/code">{t('i_have_code')}</Link>
          )}
          <Link to="/login">{t('title.login')}</Link>
        </StyledForm>
      )}
    />
  );
}
